<template>
  <el-form
    :model="form"
    ref="form">
    <el-form-item
      :label="L10n('employee')"
      prop="approvedForPaymentByEmployeeID"
      :rules="getValidationRule('required')"
      class="material-style">
      <select-response
        :model.sync="form.approvedForPaymentByEmployeeID"
        :data="dataSourceEmployee.records"
        :isLoading="dataSourceEmployee.loading"
      ></select-response>
    </el-form-item>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormQuoteApproved',
  mixins: [Form],
  computed: {
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true&OrderBy=name')
    }
  }
}
</script>
